// Central place for the wire contract's build-time constant and the script's
// self-limits/tuning knobs. Nothing here reads from the URL or postMessage --
// INGEST_ORIGIN is baked in at build time (see tsup.config.ts / README).

export const INGEST_ORIGIN = __INGEST_ORIGIN__;
export const RECORDER_VERSION = __RECORDER_VERSION__;

/** sessionStorage key used to persist {recording_id, token, startedAt} across page loads. */
export const SESSION_STORAGE_KEY = '__uirec';

/** rrweb event batching: flush a /chunks upload every N ms or every N events, whichever first. */
export const FLUSH_INTERVAL_MS = 3000;
export const FLUSH_MAX_EVENTS = 200;

/** Outbox retry cadence for chunks still awaiting a 2xx ack. */
export const FLUSH_RETRY_INTERVAL_MS = 2000;

/** Bounded outbox cap -- oldest chunks are dropped (with a console warning) past this. */
export const OUTBOX_MAX_CHUNKS = 200;
export const OUTBOX_MAX_BYTES = 4 * 1024 * 1024; // ~4MB

/** Channel cadence. */
export const HEARTBEAT_INTERVAL_MS = 5000;
export const POLL_INTERVAL_MS = 3000;

/** Max attempts (initial + retries) for an ACTIVITY /signal send before
 * giving up on that one send. Bounded so a stuck retry can't block the
 * serialized send queue forever; hello/heartbeat never retry at all (see
 * Channel.deliverSignal). */
export const SIGNAL_ACTIVITY_MAX_ATTEMPTS = 3;

/** Curated activity payload must stay under 8KB per the /signal contract. */
export const ACTIVITY_MAX_BYTES = 8 * 1024;
export const CURATED_LABEL_MAX_LEN = 60;
/** Cap on long URL-ish fields (navigation href/url) inside a curated activity,
 * so a giant SSO/redirect query string can't blow the ACTIVITY_MAX_BYTES cap. */
export const NAV_URL_MAX_LEN = 2048;
export const RAGE_CLICK_THRESHOLD = 4;
export const RAGE_CLICK_WINDOW_MS = 2000;

/** Per-request timeout for postJson -- bounds how long a hung fetch (e.g. a
 * dead tunnel/proxy) can block a caller that's awaiting it, most importantly
 * the finalize flow's drain, which must not be able to hang forever. */
export const POST_JSON_TIMEOUT_MS = 10_000;

/** Self-limits: stop and clear the session if any of these trip. */
export const MAX_CONSECUTIVE_FLUSH_FAILURES = 10;
export const SESSION_MAX_DURATION_MS = 2 * 60 * 60 * 1000; // 2h
